import { LOAN_DETAILS_CARD_PENDING_STATUS_TEXT } from "./Constant";

export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const sort = (items: string[]) => {
  return [...items].sort((a, b) =>
    a.toLowerCase().localeCompare(b.toLowerCase())
  );
};

export const formatDollarAmount = (amountStr: string): string | null => {
  const amount = parseFloat(amountStr);
  if (isNaN(amount)) {
    console.log("Invalid input format. Please provide a valid numeric value.");
    return null;
  }

  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  }).format(amount);

  return formattedAmount;
};

export const formatLoanAmount = (value?: number | null): string => {
  if (value == null || value === 0) {
    return LOAN_DETAILS_CARD_PENDING_STATUS_TEXT;
  }
  return formatDollarAmount(value.toString()) ?? LOAN_DETAILS_CARD_PENDING_STATUS_TEXT;
};

export const getLastName = (name: string) => {
  const nameArray = name.split(" ");
  return nameArray[nameArray.length - 1];
};

export const isNonEmptyString = (value: string | null | undefined): boolean => {
  return value != null && value.trim() !== "";
};

export const splitAndCapitalizeWords = (value: string): string => {
  return value
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, char => char.toUpperCase());
};

export const truncateText = (value: string, maxLength: number): string => {
  if (value.length >= maxLength) {
    return value.substring(0, maxLength).trim() + '...';
  }

  return value;
};

export const formatNotificationDate = (date: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  return new Date(date).toLocaleDateString('en-US', options);
};
export const formatPhoneNumber = (
  value: string | null | undefined
): string => {
  if (value == null || value === "") {
    return "";
  }

  const digits = value.replace(/\D/g, "");

  const normalized =
    digits.length === 11 && digits.startsWith("1")
      ? digits.slice(1)
      : digits;

  if (normalized.length !== 10) {
    return "";
  }

  const area = normalized.slice(0, 3);
  const prefix = normalized.slice(3, 6);
  const line = normalized.slice(6);

  return `(${area}) ${prefix}-${line}`;
};